/* ============================================================
   CVR改善 拡張: RTE画像クリック拡大（Lightbox）
   対象: pages / rich-text section / product description 内の <img>
   目的: ショッピングガイド等の情報系画像を細部まで見せて購入判断を助ける
   ロールバック: このファイルを削除＋theme.liquidのscript行を消せば復元
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '.rte img, .shopify-section .rte img, main .rte img, .page__content img, .page-content img';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function buildLightbox() {
    if (document.getElementById('cvr-lightbox')) return document.getElementById('cvr-lightbox');
    var lb = document.createElement('div');
    lb.id = 'cvr-lightbox';
    lb.className = 'cvr-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', '画像拡大表示');
    lb.innerHTML = ''
      + '<button type="button" class="cvr-lightbox__close" aria-label="閉じる">&times;</button>'
      + '<img class="cvr-lightbox__img" alt="">';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('cvr-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
    });
    return lb;
  }

  function open(src, alt) {
    var lb = buildLightbox();
    var img = lb.querySelector('.cvr-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    var lb = document.getElementById('cvr-lightbox');
    if (!lb) return;
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var img = lb.querySelector('.cvr-lightbox__img');
    if (img) img.src = '';
  }

  function hydrate(scope) {
    var root = scope || document;
    var imgs = root.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.dataset.cvrLightbox === '1') return;
      if (img.closest('a')) return; /* 既存リンクの画像は触らない */
      if (img.width && img.width < 40) return; /* アイコン類は除外 */
      img.dataset.cvrLightbox = '1';
      img.classList.add('cvr-zoomable');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.alt || '画像') + ' をクリックで拡大');
      img.addEventListener('click', function () {
        var src = img.currentSrc || img.src;
        open(src, img.alt);
      });
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var src = img.currentSrc || img.src;
          open(src, img.alt);
        }
      });
    });
  }

  ready(function () {
    hydrate(document);
    /* section rerender対応（テーマエディタ・ページ切替） */
    document.addEventListener('shopify:section:load', function (e) { hydrate(e.target); });
  });
})();
